module.exports = __webpack_public_path__ + "img/trip_sendai03.fdd2077c.jpg";